import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DashboardModulesE } from '../../../../core/models/globals';
import { NavigationService } from '../../../../core/services/navigation.service';
import { SessionService } from '../../../../core/services/session.service';

@Component({
  selector: 'app-show-all-deployment-sessions',
  templateUrl: './show-all-deployment-sessions.component.html',
  styleUrls: ['./show-all-deployment-sessions.component.scss']
})
export class ShowAllDeploymentSessionsComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ShowAllDeploymentSessionsComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
        dashboardCardValue: any,
        cardVariable: any,
        cardType: string,
        cardLabelValue: string
    },
    private navService: NavigationService,
    private router: Router,
    private sessionService: SessionService,
  ) { }

  cardVariable = this.data.cardVariable;

  ngOnInit(): void {
    if (this.data.dashboardCardValue) {
      let i = 0;
      if (this.data.cardVariable.title.toLowerCase() == DashboardModulesE.AvailableResources.toLowerCase()) {
        this.cardVariable.title = this.cardVariable.title + " : " + this.data.cardLabelValue.toUpperCase();
        this.data.dashboardCardValue.forEach(dep => {
          if (i == 0) {
            this.cardVariable.labels = [dep.name];
            if (this.data.cardLabelValue.toLowerCase().indexOf('cores') != -1) {
              this.cardVariable.data = [dep.availableCpu + " Cores"];
              this.cardVariable.tooltip = ['Available Physical CPU cores']
            }
            else if (this.data.cardLabelValue.toLowerCase() == 'ram') {
              this.cardVariable.data = [dep.availableRam + " GB"];
              this.cardVariable.tooltip = ['Available RAM in GB']
            }
            else if (this.data.cardLabelValue.toLowerCase() == 'gpu') {
              this.cardVariable.data = [dep.availableGpu + " GB"];
              this.cardVariable.tooltip = ['Available GPU in GB']
            }
            i += 1;
          }
          else {
            this.cardVariable.labels.push(dep.name);
            if (this.data.cardLabelValue.toLowerCase().indexOf('cores') != -1) {
              this.cardVariable.data.push(dep.availableCpu + " Cores");
              this.cardVariable.tooltip.push('Available Physical CPU cores')
            }
            else if (this.data.cardLabelValue.toLowerCase() == 'ram') {
              this.cardVariable.data.push(dep.availableRam + " GB");
              this.cardVariable.tooltip.push('Available RAM in GB')
            }
            else if (this.data.cardLabelValue.toLowerCase() == 'gpu') {
              this.cardVariable.data.push(dep.availableGpu + " GB");
              this.cardVariable.tooltip.push('Available GPU in GB')
            }
          }
        })
      }
      else {
        this.data.dashboardCardValue.forEach(dep => {
          if (i == 0) {
            this.cardVariable.labels = [dep.deployment];
            this.cardVariable.data = [dep.totalSessions];
            i += 1;
          }
          else {
            this.cardVariable.labels.push(dep.deployment);
            this.cardVariable.data.push(dep.totalSessions);
          }
        })
      }
    }
  }

  onClose() {
    this.dialogRef.close({ data: false });
  }

  onDataClick(title, index): void {
    if (title.indexOf(DashboardModulesE.AvailableResources) != -1) {
      return;
    }
    this.sessionService.dashboardSessionRedirectSort = "deployment," + index;
    this.dialogRef.close({ data: false });
    this.router.navigate(["/Sessions List"]);
  }

  navigateToComponent(title) {
    if (title.indexOf(DashboardModulesE.AvailableResources) != -1) {
      return;
    }
    this.dialogRef.close({ data: false });
    this.router.navigate(['/Sessions List'])
  }
}
